import type { TFunction } from 'i18next'

import { BidUpdateCreatedBy } from '@/features/bidding/constants'

export const getCreatedByEmoji = (createdBy: BidUpdateCreatedBy): string => {
  switch (createdBy) {
    case BidUpdateCreatedBy.TRADER:
      return '👤'
    case BidUpdateCreatedBy.BOT:
      return '🤖'
    default:
      return ''
  }
}

export const getCreatedByLabel = (createdBy: BidUpdateCreatedBy, t: TFunction): string =>
  t(`bidding.results.created_by_value.${createdBy}`)
